import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const ConsigeeDocs = ({ shipment }) => {

    if (shipment.consigneeDocuments && shipment.consigneeDocuments.length) {
        return (
            <Row className="mb-3 mt-3">
                <Col>
                    <span className="bold">Delivery Documents:</span><br />
                    {shipment.consigneeDocuments.map((document, index) => <a href={document.url} target="_blank" rel="noopener noreferrer " key={index}><span className='text-capitalize'>{document.name}</span></a>)}
                </Col>
            </Row>
        )
    } else { return null }
}

export default ConsigeeDocs